"use client";

import { useState, useEffect } from "react";
import Button from "./Button"; // Assuming we're using the Button component from earlier
import "./styles/TransactionModal.css"; // Assuming you have a CSS file for styling
import { Icons } from "../assets/icons/Icons";

const TransactionModal = ({
    isOpen,
    onClose,
    title = "Transaction Details",
    details = [],
    total,
    actionText = "Confirm",
    onAction,
    showDivider = true,
}) => {
    const [isClosing, setIsClosing] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsClosing(false);
            setShouldRender(true);
        } else if (shouldRender) {
            // Start the closing animation
            setIsClosing(true);

            // Remove from DOM after animation completes
            const timer = setTimeout(() => {
                setShouldRender(false);
            }, 300); // Match animation duration (0.3s)

            return () => clearTimeout(timer);
        }
    }, [isOpen, shouldRender]);

    const handleClose = () => {
        setIsClosing(true);

        // Call the onClose prop after animation completes
        setTimeout(() => {
            onClose();
        }, 300); // Match animation duration (0.3s)
    };

    const handleAction = () => {
        setTimeout(() => {
            onAction();
        }, 300); // Match animation duration (0.3s)
    };

    if (!shouldRender) return null;

    return (
        <div className={`t-modal-overlay ${isClosing ? "closing" : ""}`}>
            <div
                className={`t-modal-container ${
                    isClosing ? "closing" : "opening"
                }`}
            >
                <div className="t-modal-content">
                    <div
                        onClick={handleClose}
                        className="d-flex justify-content-end align-content-end"
                        style={{ cursor: "pointer" }}
                    >
                        <Icons.CloseWithBG />
                    </div>
                    <h2 className="t-modal-title">{title}</h2>

                    <div className="details-container">
                        {details.map((detail, index) => (
                            <div key={index} className="detail-row">
                                <span className="detail-label">
                                    {detail.label}
                                </span>
                                <span className="detail-value">
                                    {detail.value}
                                </span>
                            </div>
                        ))}

                        {showDivider && <div className="divider"></div>}

                        {total && (
                            <div className="detail-row total-row">
                                <span className="detail-label">Total</span>
                                <span className="detail-value">{total}</span>
                            </div>
                        )}
                    </div>

                    <div className="t-modal-actions">
                        <Button
                            variant="primary"
                            onClick={handleAction}
                            fullWidth={true}
                        >
                            {actionText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransactionModal;
